import { useEffect, useState } from "react";
import { listNationalities } from "../api/coredata.api";

// Module-level cache so /api/coredata/nationalities/ is hit at most once per
// browser session. The list is small (~84 rows) and rarely changes.
let _cache = null;
let _inflight = null;

/**
 * Hook returning a stable map of `{ [uuid]: { id, name, code } }` plus a
 * helper `nameOf(uuid)` that returns "—" for unknown ids and is safe to call
 * from a render path that has fired before the fetch resolved.
 */
export default function useNationalities() {
  const [byId, setById] = useState(_cache || {});

  useEffect(() => {
    if (_cache) return;
    if (!_inflight) {
      _inflight = listNationalities()
        .then((res) => {
          const list = Array.isArray(res.data) ? res.data : (res.data?.results || []);
          const map = {};
          for (const n of list) map[n.id] = n;
          _cache = map;
          return map;
        })
        .catch(() => ({}));
    }
    let alive = true;
    _inflight.then((map) => { if (alive) setById(map); });
    return () => { alive = false; };
  }, []);

  const nameOf = (uuid) => (uuid && byId[uuid]?.name) || "—";
  const codeOf = (uuid) => (uuid && byId[uuid]?.code) || "";
  return { byId, nameOf, codeOf };
}
